import { render, staticRenderFns } from "./InformationReview.vue?vue&type=template&id=c28a38b8&"
import script from "./InformationReview.vue?vue&type=script&lang=js&"
export * from "./InformationReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports